import React from 'react';
import { Wrapper, Drawer } from '@/components';
import { i18n, thumbnail7n, priceFormat } from '@/utils';
import Icon from './icon';
import { Shop } from '@/sunzi';
import { ElectricCard } from './mini-me';
import styles from './style.less';

interface RelatedCardProps {
  /** 商店信息 */
  shop: Shop;
  /** 合成图片 */
  miniMeImage: string;
  /** 电子卡数据 */
  electricCard: ElectricCard;
  /** 关闭回调 */
  onClose: () => void;
  /** 确认回调 */
  onConfirm: (addStatus: boolean) => void;
}

const RelatedCard: React.FC<RelatedCardProps> = ({
  shop,
  miniMeImage,
  electricCard,
  onClose,
  onConfirm
}) => {
  return <Wrapper className={styles.relatedCard}>
    <Drawer
      mask
      className={styles.relatedCardDrawer}
    >
      <div className={styles.previous} onClick={onClose}>
        <Icon type="arrow-left" color="#000" size={30} />
      </div>
      <div className={styles.photo}>
        <img src={miniMeImage} alt="compose image" />
        <img src="https://assets.sunzi.cool/new-mini-me/digital-photo.png" alt="digital photo" />
      </div>
      <div className={styles.info}>
        <p className={styles.infoTitle}>
          <span>+{priceFormat(shop.currencySymbol, electricCard.price)}</span>
          {electricCard.title || 'Get HD digital photo of the above preview'}
        </p>
        <p className={styles.infoDescription}>
          <span>
            {electricCard.description || 'By choosing this option, you will get an HD digital photo of the above preview. The photo will be sent to your email 3-5 days after you receive the product.'}
          </span>
        </p>
      </div>
      <div className={styles.button} onClick={() => onConfirm(true)}>{i18n.format("modules.mini.me.card.next")}</div>
      <div className={styles.divider}>
        <span>{i18n.format("modules.mini.me.or")}</span>
      </div>
      <div className={styles.button} onClick={() => onConfirm(false)}>{i18n.format("modules.mini.me.no.thanks")}</div>
    </Drawer>
  </Wrapper>
}

export default RelatedCard;